'use strict';

let $ = window.jQuery;

const api_url = '/api/request.php';
const rappel_url = '/api/rappel.php';
const api_request_simulateur_url = '/api/simulateur.php';
const simulateur_url = '/api/simulation.php';
const formation_url = '/api/course_subscribe.php';
const business_url = '/api/business_recall.php';
const webinar_url = '/api/webinar_form.php';

export class ITGWebservice {
    static sendRequest (url, endpoint, params, httpheader = null, async = true) {
        return $.ajax({
            url: url,
            type: 'POST',
            async: async,
            data: {
                endpoint: endpoint,
                params: JSON.stringify(params),
                httpheader: httpheader
            }
            /* ,
            success: (data, textStatus, jqXHR) => {
                callback(data);
            },
            error: (jqXHR, textStatus, errorThrown) => {
                console.log(jqXHR);
                console.log( errorThrown);
            } */
        });// .done(function() {callback(this.responseText);});
    }

    static get api_url () { return api_url };
    static get rappel_url () { return rappel_url };
    static get api_request_simulateur_url () { return api_request_simulateur_url };
    static get simulateur_url () { return simulateur_url };
    static get formation_url () { return formation_url };
    static get business_url () { return business_url };
    static get webinar_url () { return webinar_url };

    static get endpoint_contact () { return 'contacts' };
    static get endpoint_simulateur_tjm () { return 'dailyFees' };
    static get endpoint_simulateur_salary () { return 'salary' };
    static get endpoint_job_category () { return 'specialities' };
    static get endpoint_trainings () { return 'trainings' };
    static get endpoint_webinar_registration () { return '' };

    static endpoint_analytics_user_ids (query) {
        return `google_analytics_user_ids/search?query=${query}`;
    }

    static endpoint_registration (trainingID) {
        return `trainings/${trainingID}/registration`;
    };

    static endpoint_training_locations (place) {
        return `training_locations/${place}`;
    };

    static endpoint_registration_confirm (hash) {
        return `registrations/${hash}/confirm`;
    };

    static endpoint_registration_cancel (hash) {
        return `registrations/${hash}/cancel`;
    };
}



// WEBPACK FOOTER //
// ./front/js/services/ITGWebservice.js